import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Spinner() {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
